"use client";

import React from "react";
import Image from "next/image";

export default function OdooMoreCallout({ position = "bottom" }) {
  if (position === "top") {
    return (
      <div className="flex justify-center px-6 sm:px-12 lg:px-24 -mt-16 md:-mt-24">
        <div className="flex items-center justify-center gap-2 sm:gap-3">
          <Image
            src="/odoo/arrows/grey_arrow_loop_02.svg"
            width={140}
            height={100}
            style={{ width: "140px", height: "auto" }}
            className="hidden sm:block rotate-[50deg] scale-x-[-1] mt-7 me-3 opacity-60 brightness-0 invert"
            alt=""
          />
          <Image
            src="/odoo/snippets/s_wd_persona/bella.webp"
            width={60}
            height={60}
            className="hidden md:inline-block rounded-full me-2"
            alt=""
          />
          <div className="bg-white/10 rounded-full shadow-lg p-3 px-4 sm:px-5 text-white">
            <i>But wait! There&apos;s more.</i>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute left-1/2 bottom-6 sm:bottom-10 -translate-x-1/2 w-full px-6 sm:px-12 lg:px-24 pointer-events-none">
      <div className="container mx-auto">
        <div className="flex items-center justify-center gap-2 sm:gap-3 pointer-events-auto">
          <Image
            src="/odoo/arrows/grey_arrow_loop_02.svg"
            width={140}
            height={100}
            style={{ width: "140px", height: "auto" }}
            className="hidden sm:block rotate-[50deg] scale-x-[-1] mt-7 me-3 opacity-60 brightness-0 invert"
            alt=""
          />
          <Image
            src="/odoo/snippets/s_wd_persona/bella.webp"
            width={60}
            height={60}
            className="hidden md:inline-block rounded-full me-2"
            alt=""
          />
          <div className="bg-white/10 rounded-full shadow-lg p-3 px-4 sm:px-5 text-white">
            <i>But wait! There&apos;s more.</i>
          </div>
        </div>
      </div>
    </div>
  );
}